const allStepTypes = [
  { text: 'Accommodation', value: 'accommodation', icon: 'mdi-hotel' },
  { text: 'Adventure', value: 'adventure', icon: 'mdi-image-filter-hdr' },
  { text: 'Attraction', value: 'attraction', icon: 'mdi-ticket' },
  { text: 'Bus', value: 'bus', icon: 'mdi-bus' },
  { text: 'Car', value: 'car', icon: 'mdi-car' },
  { text: 'Drink', value: 'drink', icon: 'mdi-glass-cocktail' },
  { text: 'Event', value: 'event', icon: 'mdi-ticket' },
  { text: 'Flight', value: 'flight', icon: 'mdi-airplane' },
  { text: 'Food', value: 'food', icon: 'mdi-silverware-fork-knife' },
  { text: 'Institution', value: 'institution', icon: 'mdi-domain' },
  { text: 'Service', value: 'service', icon: 'mdi-toolbox' },
  { text: 'Shopping', value: 'shopping', icon: 'mdi-shopping' },
  { text: 'Train', value: 'train', icon: 'mdi-train' },
  { text: 'Wellness', value: 'wellness', icon: 'mdi-spa' }
]

/**
 * @typedef {import('../models/TripStep').default} TripStep
 * @param {TripStep} step
 */
function getStepIcon (step) {
  const s = allStepTypes.find(x => x.value === step.$.type)
  return s ? s.icon : null
}

export {
  allStepTypes,
  getStepIcon
}
